<template>
  <svg
    id="Сгруппировать_4276"
    data-name="Сгруппировать 4276"
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="9.926"
    viewBox="0 0 15 9.926"
  >
    <path
      id="Контур_4037"
      data-name="Контур 4037"
      d="M-350,119.865V118.58c.327,0,.654,0,.981,0,.053,0,.064-.028.079-.064l3.161-7.689.328-.8,2.951,5,2.962-5c.015.034.026.055.034.077l2.144,5.236,1.3,3.171c.015.036.026.065.079.064.327,0,.654,0,.981,0v1.285c-.027,0-.054,0-.08,0H-340.3V118.58h.788l-.772-2.14-2.221,3.519-2.221-3.519-.773,2.145h.791v1.284H-349.9C-349.932,119.869-349.966,119.866-350,119.865Z"
      transform="translate(350 -110.033)"
      fill="#fff"
    />
  </svg>
</template>

<script>
  export default {
    name: 'IconMetro',
  }
</script>
